/**
 * تابع ترجمه پیام‌های انگلیسی API به فارسی
 * این تابع پیام‌های رایج از API را به فارسی تبدیل می‌کند
 */
export const translateActionMessage = (message) => {
  if (!message || typeof message !== 'string') {
    return message;
  }

  // تبدیل به lowercase برای مقایسه
  const lowerMessage = message.toLowerCase().trim();

  // نقشه ترجمه پیام‌های رایج
  const translations = {
    // پیام‌های ایجاد
    'action created successfully': 'اقدام با موفقیت ایجاد شد',
    'action item created successfully': 'آیتم اقدام با موفقیت ایجاد شد',
    'action resource created successfully': 'منبع اقدام با موفقیت ایجاد شد',
    'action comment created successfully': 'نظر با موفقیت ثبت شد',
    'action attachment created successfully': 'پیوست با موفقیت بارگذاری شد',
    'raci created successfully': 'RACI با موفقیت ثبت شد',
    'request created successfully': 'درخواست با موفقیت ثبت شد',
    'created successfully': 'با موفقیت ایجاد شد',

    // پیام‌های به‌روزرسانی
    'action updated successfully': 'اقدام با موفقیت به‌روزرسانی شد',
    'action item updated successfully': 'آیتم اقدام با موفقیت به‌روزرسانی شد',
    'action resource updated successfully': 'منبع اقدام با موفقیت به‌روزرسانی شد',
    'action comment updated successfully': 'نظر با موفقیت به‌روزرسانی شد',
    'action attachment updated successfully': 'توضیحات پیوست به‌روزرسانی شد',
    'action progress updated successfully': 'پیشرفت اقدام به‌روزرسانی شد',
    'updated successfully': 'با موفقیت به‌روزرسانی شد',

    // پیام‌های حذف
    'action deleted successfully': 'اقدام با موفقیت حذف شد',
    'action item deleted successfully': 'آیتم اقدام با موفقیت حذف شد',
    'action resource deleted successfully': 'منبع اقدام با موفقیت حذف شد',
    'action comment deleted successfully': 'نظر با موفقیت حذف شد',
    'action attachment deleted successfully': 'پیوست با موفقیت حذف شد',
    'raci deleted successfully': 'RACI با موفقیت حذف شد',
    'deleted successfully': 'با موفقیت حذف شد',

    // پیام‌های دیگر
    'action accepted successfully': 'اقدام با موفقیت پذیرفته شد',
    'action closed successfully': 'اقدام با موفقیت بسته شد',
    'close request sent successfully': 'درخواست بستن با موفقیت ارسال شد',
    'action item started successfully': 'آغاز آیتم با موفقیت ثبت شد',
    'action item completed successfully': 'آیتم به عنوان انجام‌شده علامت‌گذاری شد',
    'raci member added successfully': 'عضو RACI با موفقیت اضافه شد',
    'item raci deleted successfully': 'RACI آیتم با موفقیت حذف شد',
    'file uploaded successfully': 'فایل با موفقیت بارگذاری شد',
    'attachment deleted successfully': 'پیوست با موفقیت حذف شد',
    'attachment description updated successfully': 'توضیحات پیوست با موفقیت به‌روزرسانی شد',
    'comment added successfully': 'نظر با موفقیت ثبت شد',
    'comment deleted successfully': 'نظر با موفقیت حذف شد',
    'resource updated successfully': 'منبع با موفقیت به‌روزرسانی شد',
    'resource created successfully': 'منبع با موفقیت ایجاد شد',
    'resource deleted successfully': 'منبع با موفقیت حذف شد',
    'item resource updated successfully': 'منبع آیتم با موفقیت به‌روزرسانی شد',
    'item resource created successfully': 'منبع آیتم با موفقیت ایجاد شد',
    'item resource deleted successfully': 'منبع آیتم با موفقیت حذف شد',
    'item deleted successfully': 'آیتم با موفقیت حذف شد',
    'item updated successfully': 'آیتم با موفقیت به‌روزرسانی شد',
    'item created successfully': 'آیتم با موفقیت ایجاد شد',
    'raci created': 'RACI ثبت شد',
    'raci deleted': 'RACI حذف شد',
    'raci updated': 'RACI به‌روزرسانی شد',
    'notifications marked as read': 'اعلان‌ها به عنوان خوانده شده علامت‌گذاری شدند',
    'notification marked as read': 'اعلان به عنوان خوانده شده علامت‌گذاری شد',
    'notification marked as unread': 'اعلان به عنوان خوانده نشده علامت‌گذاری شد',
    'notification deleted successfully': 'اعلان با موفقیت حذف شد',
    'preferences updated successfully': 'تنظیمات با موفقیت به‌روزرسانی شد',
    'raci member added successfully': 'عضو RACI با موفقیت اضافه شد',
    'item raci deleted successfully': 'RACI آیتم با موفقیت حذف شد',
  };

  // بررسی دقیق
  if (translations[lowerMessage]) {
    return translations[lowerMessage];
  }

  // بررسی جزئی (برای پیام‌هایی که ممکن است اضافه‌ای داشته باشند)
  for (const [english, persian] of Object.entries(translations)) {
    if (lowerMessage.includes(english)) {
      return persian;
    }
  }

  // اگر ترجمه پیدا نشد، پیام اصلی را برگردان
  return message;
};

/**
 * تابع برای دریافت پیام موفقیت فارسی
 * اگر پیام از API انگلیسی باشد، آن را به فارسی تبدیل می‌کند
 * در غیر این صورت از پیام پیش‌فرض فارسی استفاده می‌کند
 */
export const getSuccessMessage = (apiMessage, defaultPersianMessage) => {
  if (apiMessage) {
    const translated = translateActionMessage(apiMessage);
    // اگر ترجمه انجام شد (یعنی پیام انگلیسی بود)، از ترجمه استفاده کن
    if (translated !== apiMessage) {
      return translated;
    }
    // اگر پیام از قبل فارسی بود، از همان استفاده کن
    return apiMessage;
  }
  // اگر پیامی از API نیامد، از پیام پیش‌فرض استفاده کن
  return defaultPersianMessage;
};

